export default "__VITE_ASSET__CFUuJy4C__"